import { SC } from '../../styles/theme';
import { BRAND, isBrandOV, isMarketGB } from '../../constants/main';
import { TopNavbarStyledAC } from './AC/TopNavbarStyled.AC';
import { TopNavbarStyledAP } from './AP/TopNavbarStyled.AP';
import { TopNavbarStyledDS } from './DS/TopNavbarStyled.DS';
import { TopNavbarStyledOV } from './OV/TopNavbarStyled.OV';
import { TopNavbarStyledOV as TopNavbarStyledOV_BG } from './OV/GB/TopNavbarStyled.OV';
import { TopNavbarStyled } from './TopNavbarStyled';

export interface TopNavbarProps extends SC {
    title?: string;
    step?: string;
    showSaveButton?: boolean;
    onGoBack?: () => void;
    isLoading?: boolean;
    isBackButtonHidden?: boolean;
    isBasket?: boolean;
}

export const TopNavbar = (props: TopNavbarProps) => {
    if (isBrandOV) return isMarketGB ? <TopNavbarStyledOV_BG {...props} /> : <TopNavbarStyledOV {...props} />;
    if (BRAND === 'AC') return <TopNavbarStyledAC {...props} />;
    if (BRAND === 'AP') return <TopNavbarStyledAP {...props} />;
    if (BRAND === 'DS') return <TopNavbarStyledDS {...props} />;
    return <TopNavbarStyled {...props} />;
};

export default TopNavbar;
